export default "__VITE_ASSET__D9pkpl9T__"